import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
export default observer(function NumbersComponent(cat,key) {     
    const currentyear = new Date().getFullYear();    
    return (
      <section data-bs-version="5.1" className="features6 shopm5 cid-uATHtAM0YT" id="afeatures6-7">
      <div className="container">
          <div className="row">
              <div className="col-12 col-title">
                  <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                      <strong>Numbers</strong>
                  </h3>
                  
              </div>
          </div>
          <div className="row cards-row justify-content-start">
  
              <div className="card col-12 col-md-6 col-lg-3">
                  <div className="card-wrapper">
                      <div className="text-wrap">
                          <div className="iconfont-wrapper">
                              <span className="mbr-iconfont mobi-mbri-success mobi-mbri" style={{color:'rgb(59, 59, 59)',fill:'rgb(59, 59, 59)'}}></span>
                          </div>
                          <h5 className="card-title mbr-fonts-style mb-0 display-1"><strong>382</strong></h5>
                      </div>
                      <p className="card-text mbr-fonts-style mb-0 display-7">
                          <strong>Happy Customers</strong>
                      </p>
                  </div>
              </div>
  
              <div className="card col-12 col-md-6 col-lg-3">
                  <div className="card-wrapper">
                      <div className="text-wrap">
                          <div className="iconfont-wrapper">
                              <span className="mbr-iconfont mobi-mbri-success mobi-mbri" style={{color:'rgb(59, 59, 59)',fill:'rgb(59, 59, 59)'}}></span>
                          </div>
                          <h5 className="card-title mbr-fonts-style mb-0 display-1"><strong>2343</strong></h5>
                      </div>
                      <p className="card-text mbr-fonts-style mb-0 display-7">
                          <strong>Sales Per Month</strong>
                      </p>
                  </div>
              </div>
              <div className="card col-12 col-md-6 col-lg-3">
                  <div className="card-wrapper">
                      <div className="text-wrap">
                          <div className="iconfont-wrapper">
                              <span className="mbr-iconfont mobi-mbri-success mobi-mbri" style={{color:'rgb(59, 59, 59)',fill:'rgb(59, 59, 59)'}}></span>
                          </div>
                          <h5 className="card-title mbr-fonts-style mb-0 display-1"><strong>564</strong></h5>
                      </div>
                      <p className="card-text mbr-fonts-style mb-0 display-7">
                          <strong>Regular Customers</strong>
                      </p>
                  </div>
              </div>
              <div className="card col-12 col-md-6 col-lg-3">
                  <div className="card-wrapper">
                      <div className="text-wrap">
                          <div className="iconfont-wrapper">
                              <span className="mbr-iconfont mobi-mbri-success mobi-mbri" style={{color:'rgb(59, 59, 59)',fill:'rgb(59, 59, 59)'}}></span>
                          </div>
                          <h5 className="card-title mbr-fonts-style mb-0 display-1"><strong>134</strong></h5>
                      </div>
                      <p className="card-text mbr-fonts-style mb-0 display-7">
                          <strong>Delivery Points</strong>
                      </p>
                  </div>
              </div>
  
          </div>
      </div>
  </section>
    )
})